import { useContext } from 'react';

import type { TGeoInfoData, IGeoInfo } from '../models';
import { GeoInfo } from '../context';

export const useGeoInfo = <T extends IGeoInfo>(defaultGeo?: T): TGeoInfoData | T => {
    const geo = useContext<TGeoInfoData>(GeoInfo);

    return geo ?? defaultGeo;
};
